import { Box } from '@mui/material';
import { memo } from 'react';
import { DetailsLabelValue } from 'components/DetailsModal/DetailsLabelValue';

type Translate = (key: string) => string;

type Props = {
	operation: any;
	t: Translate;
	summaryPanelSx: object;
};

export const DetailsTechnicalSection = memo(function DetailsTechnicalSection({ operation, t, summaryPanelSx }: Props) {
	return (
		<Box sx={{ WebkitFontSmoothing: 'antialiased' }}>
			<Box sx={summaryPanelSx}>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.operationId')}
					value={operation.operationId}
					breakAll
				/>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.correlationId')}
					value={operation?.correlationId}
					breakAll
				/>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.idempotencyId')}
					value={operation?.idempotencyKey}
					breakAll
				/>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.serviceBusSessionId')}
					value={operation?.serviceBusSessionId}
					breakAll
				/>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.subject')}
					value={operation?.subject}
					breakAll
				/>
				<DetailsLabelValue
					label={t('page.webhookMonitoring.field.apiFunction')}
					value={operation?.apiFunction}
					breakAll
				/>
			</Box>
		</Box>
	);
});
